import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AdminIcon from '../shell/AdminIcon';

// Petits composants de l'Admin refondue (repris de la maquette) : pastille, interrupteur, panneau lateral.

export function Tag({ tone = '', children }) {
  return <span className={`adm-tag ${tone}`}><i aria-hidden="true" />{children}</span>;
}

/** Interrupteur accessible (role switch) : « Actif / Inactif », « Test / Reel »... */
export function Switch({ checked, onChange, label, disabled = false }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className="adm-switch"
      disabled={disabled}
      onClick={() => onChange(!checked)}
    />
  );
}

/**
 * Panneau lateral : s'ouvre par-dessus la page, se ferme par Echap, le bouton ou un clic a cote. Le focus y entre a l'ouverture et
 * revient sur ce qui l'a ouvert a la fermeture. `onRequestClose` laisse l'appelant demander confirmation (modifications non enregistrees).
 */
export function Drawer({ title, onRequestClose, children }) {
  const { t } = useTranslation('admin');
  const panneauRef = useRef(null);

  useEffect(() => {
    const precedent = document.activeElement;
    if (panneauRef.current) panneauRef.current.focus();
    const surTouche = (e) => { if (e.key === 'Escape') onRequestClose(); };
    document.addEventListener('keydown', surTouche);
    return () => {
      document.removeEventListener('keydown', surTouche);
      if (precedent && typeof precedent.focus === 'function' && document.contains(precedent)) precedent.focus();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="adm-drawer" onMouseDown={(e) => { if (e.target === e.currentTarget) onRequestClose(); }}>
      <div className="adm-drawer-panel" role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} ref={panneauRef}>
        <div className="adm-drawer-head">
          <h2>{title}</h2>
          <button type="button" className="btn btn-outline btn-sm" onClick={onRequestClose} aria-label={t('catalog.common.close')}>
            <AdminIcon name="x" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
